import { render, staticRenderFns } from "./CustomerServiceInfo.vue?vue&type=template&id=782b8008&scoped=true"
import script from "./CustomerServiceInfo.vue?vue&type=script&lang=ts"
export * from "./CustomerServiceInfo.vue?vue&type=script&lang=ts"
import style0 from "./CustomerServiceInfo.vue?vue&type=style&index=0&id=782b8008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b8008",
  null
  
)

export default component.exports